module.exports = __webpack_public_path__ + "img/icon_project08.afa366f0.png";